import { parseISO, format, isValid, parse } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const formatDate = (
  date?: string | null,
  formatString = 'dd/MM/yyyy'
): string | null => {
  if (!date?.trim()) return null;

  const parsedDate = parseISO(date);
  if (!isValid(parsedDate)) return null;

  return format(parsedDate, formatString, { locale: ptBR });
};

export const toISODateString  = (dateStr?: string | null): string | undefined => {
  if (!dateStr) return undefined;

  const parsed = parse(dateStr, 'dd/MM/yyyy', new Date());

  if (!isValid(parsed)) return undefined;

  return format(parsed, 'yyyy-MM-dd');
};
